import { z } from "zod";

// TES-1602 (TES-1600 S2) — the doctor's "Kräv vårdmöte" on the patient
// overview, for a patient whose tenant has made the onboarding meeting
// optional (`features.careMeetingOptional`, TES-1601).
//
// GET  employee-api/v1/patients/:id/care-meeting-requirement → the view
// POST employee-api/v1/patients/:id/care-meeting-requirement → requires it
//
// Doctor only. With the flag off, or for a patient who is not on the
// optional track, `canRequire` is false and `required` null, and the admin
// renders nothing: the overview is exactly what it was.

// TES-1643 (TES-1600 S8, Ö-1008) — why the meeting is required. `doctor` is
// the doctor's "Kräv vårdmöte" (free by REQUIRED_CARE_MEETING_FEE_CENTS,
// Ö-947); `declaration_flags` is set automatically when her health
// declaration raises a flag the versioned table puts in a meeting bucket
// (Ö-1007, narrowed to red and orange flags by TES-1647 / Ö-1012). Both
// cost the same
// (TES-1645, Emelie 2026-10-30: free "oavsett om systemet eller läkaren
// begär det").
export const careMeetingRequiredReasonSchema = z.enum([
  "doctor",
  "declaration_flags",
]);
export type CareMeetingRequiredReason = z.infer<
  typeof careMeetingRequiredReasonSchema
>;

export const careMeetingRequirementViewSchema = z.object({
  /** The doctor may require a meeting now. */
  canRequire: z.boolean(),
  /** Set once required; never cleared. */
  required: z
    .object({
      at: z.string(),
      /** The requiring doctor's display name, null if not found or not a doctor. */
      byName: z.string().nullable(),
      /** TES-1643 — the doctor, or flags in her health declaration. */
      reason: careMeetingRequiredReasonSchema,
    })
    .nullable(),
  /** A first consultation is booked or held: the requirement is met. */
  meetingBooked: z.boolean(),
  /**
   * What she pays for the required meeting, in minor units, whatever its
   * reason (TES-1645): 0 when it is free, otherwise the consult fee (395 kr).
   */
  feeMinor: z.number().int().min(0),
});
export type CareMeetingRequirementView = z.infer<
  typeof careMeetingRequirementViewSchema
>;
